import { TOGGLE_ASK_GEOLOCATION_PANEL } from "./displayAskGeolocationPanelReducer"

export const toggleAskGeolocationPanel = (value) => ({
    type: TOGGLE_ASK_GEOLOCATION_PANEL,
    payload: value
})